<div class="col-md-12 mb-30">
  <div class="card card-statistics mb-30">
    <div class="card-body">
      <h5 class="card-title">جزئیات رسید شماره '{{ calibrationId }}'</h5>
      <div class="row">
        <div class="form-group col-md-3"><label>شماره رسید</label><input type="text" class="form-control"
            [value]="receipt?.code || '-'" readonly /></div>
        <div class="form-group col-md-3"><label>نام مشتری</label><input type="text" class="form-control"
            [value]="receipt?.customerName || '-'" readonly /></div>
        <div class="form-group col-md-3"><label>شماره نامه</label><input type="text" class="form-control"
            [value]="receipt?.letterNumber || '-'" readonly /></div>
        <div class="form-group col-md-3"><label>تاریخ ثبت</label><input type="text" class="form-control"
            [value]="receipt?.subDatePersian || '-'" readonly /></div>
        <div class="form-group col-md-3"><label>نوع کار</label><input type="text" class="form-control"
            [value]="receipt ? (receipt.inLocation ? 'سایت' : 'آزمایشگاه') : '-'" readonly /></div>
      </div>

      <img *ngIf="InProccessing" src="assets/Loading.gif" style="width: 25px;" />

      <div *ngIf="!InProccessing">
        <div class="device-list">
          <article class="device-card" *ngFor="let item of details; let i = index">
            <header class="device-card-header">
              <div class="device-identity" [title]="item.deviceTitle || ''">
                <span class="device-index">{{ i + 1 }}</span>
                <span class="device-name">{{ item.deviceName || '-' }}</span>
              </div>
              <div class="device-meta">
                <span><small>کد تجهیز</small><strong>{{ item.deviceCode || '-' }}</strong></span>
                <span><small>سریال</small><strong>{{ item.serial || '-' }}</strong></span>
                <span><small>محل کالیبراسیون</small><strong>{{ item.locationName || '-' }}</strong></span>
              </div>
            </header>

            <section class="device-section">
              <h6 class="section-title"><i class="fa fa-money"></i> اطلاعات مالی</h6>
              <div class="section-grid">
                <div class="info-item">
                  <span>مبلغ واحد (ریال)</span>
                  <strong class="numeric-value">{{ getUnitPrice(item) | number }}</strong>
                </div>
                <div class="info-item">
                  <span>T4</span>
                  <strong class="numeric-value">{{ getFinalT4(item) | number }}</strong>
                </div>
                <div class="info-item">
                  <span>افزایش مدیر (درصد)</span>
                  <strong class="numeric-value">{{ item.incPercentModir | number }}</strong>
                </div>
                <div class="info-item">
                  <span>افزایش مدیر (ریال)</span>
                  <strong class="numeric-value">{{ item.incRailModir | number }}</strong>
                </div>
              </div>
            </section>

            <section class="device-section additions-section">
              <h6 class="section-title"><i class="fa fa-plus-circle"></i> اضافه‌ها</h6>
              <div class="section-grid">
                <div class="input-item">
                  <label [for]="'incRailPercent-' + i">تعرفه اضافه تجهیز (درصد)</label>
                  <input [id]="'incRailPercent-' + i" type="number" class="form-control detail-number-input"
                    [(ngModel)]="item.incRailPercent" (ngModelChange)="calculateTotals()" step="any" [disabled]="savingIndex !== null || confirming" />
                </div>
                <div class="input-item">
                  <label [for]="'incRail-' + i">تعرفه اضافه تجهیز (ریال)</label>
                  <input [id]="'incRail-' + i" type="number" class="form-control detail-number-input"
                    [(ngModel)]="item.incRail" (ngModelChange)="calculateTotals()" step="any" [disabled]="savingIndex !== null || confirming" />
                </div>
                <div class="input-item">
                  <label [for]="'incT4Percent-' + i">T4 اضافه (درصد)</label>
                  <input [id]="'incT4Percent-' + i" type="number" class="form-control detail-number-input"
                    [(ngModel)]="item.incT4Percent" (ngModelChange)="calculateTotals()" step="any" [disabled]="savingIndex !== null || confirming" />
                </div>
                <div class="input-item">
                  <label [for]="'incT4-' + i">T4 اضافه (دقیقه)</label>
                  <input [id]="'incT4-' + i" type="number" class="form-control detail-number-input"
                    [(ngModel)]="item.incT4" (ngModelChange)="calculateTotals()" step="any" [disabled]="savingIndex !== null || confirming" />
                </div>
              </div>
            </section>

            <section class="device-section">
              <label [for]="'confirm-description-' + item.calibrationDetailId">توضیحات تأیید کار و پیش‌فاکتور</label>
              <textarea [id]="'confirm-description-' + item.calibrationDetailId" class="form-control"
                dir="rtl" rows="4" maxlength="2000" [(ngModel)]="item.confirmInvoiceDescription"
                [disabled]="savingIndex !== null || confirming"></textarea>
            </section>

            <section class="device-section result-section">
              <h6 class="section-title"><i class="fa fa-check-square-o"></i> نتیجه</h6>
              <div class="result-grid">
                <div class="final-total">
                  <span>مبلغ پایه ردیف (ریال)</span>
                  <strong>{{ getInvoiceTotal(item) | number }}</strong>
                </div>
                <div class="final-total">
                  <span>مبلغ ردیف با افزایش‌ها (ریال)</span>
                  <strong>{{ getFinalTotal(item) | number }}</strong>
                </div>
                <div class="text-result">
                  <span>ملاحظات</span>
                  <p>{{ item.priceDescription || '-' }}</p>
                </div>
                <div class="text-result">
                  <span>توضیحات نامه</span>
                  <p>{{ item.description || '-' }}</p>
                </div>
                <div class="text-result">
                  <span>توضیحات کارشناس</span>
                  <p>{{ item.descriptionExpert || '-' }}</p>
                </div>
                <div class="save-area">
                  <button type="button" class="btn btn-success" [disabled]="savingIndex !== null || confirming"
                    (click)="saveDetail(item, i)"><i class="fa fa-save"></i> ثبت اطلاعات</button>
                  <img *ngIf="savingIndex === i" src="assets/Loading.gif" class="row-loading" />
                </div>
              </div>
            </section>
          </article>

          <div class="empty-detail" *ngIf="details.length === 0">تجهیزی برای این رسید ثبت نشده است.</div>
        </div>

        <div class="totals-footer">
          <div><span>جمع مبلغ پایه دستگاه‌ها (ریال)</span><strong>{{ totals.baseDevicesTotal | number }}</strong></div>
          <div><span>جمع افزایش مدیر (ریال)</span><strong>{{ totals.managerIncreaseTotal | number }}</strong></div>
          <div><span>جمع تعرفه اضافه تجهیز (ریال)</span><strong>{{ totals.additionalIncreaseTotal | number }}</strong></div>
          <div><span>جمع کل دستگاه‌ها (ریال)</span><strong>{{ totals.devicesTotal | number }}</strong></div>
          <div><span>جمع دستگاه‌های محل مشتری (ریال)</span><strong>{{ totals.siteDevicesTotal | number }}</strong></div>
          <div><span>جمع دستگاه‌های آزمایشگاه (ریال)</span><strong>{{ totals.labDevicesTotal | number }}</strong></div>
          <div><span>هزینه خدمات (ریال)</span><strong>{{ totals.serviceCost | number }}</strong></div>
          <div><span>جمع قبل از تخفیف (ریال)</span><strong>{{ totals.subTotal | number }}</strong></div>
          <div><span>تخفیف ({{ totals.discountPercent | number }}٪) (ریال)</span><strong>{{ totals.discountAmount | number }}</strong></div>
          <div><span>مبلغ پس از تخفیف (ریال)</span><strong>{{ totals.afterDiscount | number }}</strong></div>
          <div><span>ارزش افزوده ({{ totals.vatPercent | number }}٪) (ریال)</span><strong>{{ totals.vatAmount | number }}</strong></div>
          <div><span>جمع کل نهایی (ریال)</span><strong>{{ totals.finalTotal | number }}</strong></div>
        </div>
        <br />
        <a target="_blank" class="btn btn-info" style="margin-left: 10px;"
          [routerLink]="['/LetterRequestCustomerForm',{id:receipt?.letterNumber}]"><i class="fa fa-edit"></i>
          نامه صادره</a>
        <button type="button" class="btn btn-success" style="margin-left: 10px;"
          [disabled]="confirming || !canConfirmFinal" (click)="openConfirmModal(confirmTemplate)">
          <i class="fa fa-check"></i> تایید نهایی
        </button>
        <img *ngIf="confirming" src="assets/Loading.gif" style="width: 25px; margin-left: 10px;" />
        <button routerLink="/CalibrationConfirmInvoice" type="button" class="btn btn-warning" [disabled]="confirming"><i
            class="fa fa-mail-reply"></i> بازگشت</button>
      </div>
    </div>
  </div>
</div>

<ng-template #confirmTemplate>
  <div class="modal-header">
    <h4 class="modal-title pull-left">تایید نهایی رسید شماره '{{ receipt?.code }}'</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="confirmModalRef.hide()"><span
        aria-hidden="true">×</span></button>
  </div>
  <div class="modal-body">آیا از تایید نهایی کار و پیش فاکتور اطمینان دارید؟</div>
  <div class="modal-footer">
    <button type="button" class="btn btn-warning" (click)="submitFinalConfirm()">تایید نهایی <i
        class="fa fa-check"></i></button>
    <button type="button" class="btn btn-danger" (click)="confirmModalRef.hide()">بستن</button>
  </div>
</ng-template>
